export const FALLBACK_ERROR_MESSAGE = "fallbackErrorMessage";

/**
 * List of all english error messages by validator
 */
const _messagesEN = {
    [FALLBACK_ERROR_MESSAGE]: "{{ propLabel }} is not valid",
    required: "{{ propLabel }} is required",
    requiredAtLeastOne: "One of these properties must be filled",
    minValue: "{{ propLabel }} minimum value is {{ validatorParams }}",
    maxValue: "{{ propLabel }} maximum value is {{ validatorParams }}",
    minLength: "{{ propLabel }} minimum length is {{ validatorParams }}",
    maxLength: "{{ propLabel }} maximum length is {{ validatorParams }}",
    date: "{{ propLabel }} only accepts date format",
    email: "{{ propLabel }} only accepts email format",
    equal: "{{ propLabel }} should equal {{ validatorParams }}",
    isInteger: "{{ propLabel }} should be an integer",
    sanitizeHtml: "{{ propLabel }} is not a valid format",
    compare: {
        equal: "{{ propLabel }} should be equal to {{ valueOrPropertyLabel }}",
        equal_without_type: "{{ propLabel }} should be equal to {{ valueOrPropertyLabel }}",
        not_equal: "{{ propLabel }} should not be equal to {{ valueOrPropertyLabel }}",
        not_equal_without_type: "{{ propLabel }} should not be equal to {{ valueOrPropertyLabel }}",
        greater: "{{ propLabel }} should be greater than {{ valueOrPropertyLabel }}",
        greater_or_equal: "{{ propLabel }} should be greater or equal to {{ valueOrPropertyLabel }}",
        less: "{{ propLabel }} should be less than {{ valueOrPropertyLabel }}",
        less_or_equal: "{{ propLabel }} should be less or equal to {{ valueOrPropertyLabel }}",

        equal_date: "{{ propLabel }} should be same day as {{ valueOrPropertyLabel }}",
        equal_without_type_date: "{{ propLabel }} should be same day as {{ valueOrPropertyLabel }}",
        not_equal_date: "{{ propLabel }} should not be same day as {{ valueOrPropertyLabel }}",
        not_equal_without_type_date: "{{ propLabel }} should not be same day as {{ valueOrPropertyLabel }}",
        greater_date: "{{ propLabel }} should be later than {{ valueOrPropertyLabel }}",
        greater_or_equal_date: "{{ propLabel }} should be later or equal to {{ valueOrPropertyLabel }}",
        less_date: "{{ propLabel }} should be earlier than {{ valueOrPropertyLabel }}",
        less_or_equal_date: "{{ propLabel }} should be earlier or equal to {{ valueOrPropertyLabel }}",

        equal_time: "{{ propLabel }} should be same time as {{ valueOrPropertyLabel }} either {{ valueOrPropertyLabelTime }}",
        equal_without_type_time: "{{ propLabel }} should be same time as {{ valueOrPropertyLabel }} either {{ valueOrPropertyLabelTime }}",
        not_equal_time: "{{ propLabel }} should not be same time as {{ valueOrPropertyLabel }} either {{ valueOrPropertyLabelTime }}",
        not_equal_without_type_time: "{{ propLabel }} should not be same time as {{ valueOrPropertyLabel }} either {{ valueOrPropertyLabelTime }}",
        greater_time: "{{ propLabel }} should be later than {{ valueOrPropertyLabel }} either {{ valueOrPropertyLabelTime }}",
        greater_or_equal_time: "{{ propLabel }} should be later or equal to {{ valueOrPropertyLabel }} either {{ valueOrPropertyLabelTime }}",
        less_time: "{{ propLabel }} should be earlier than {{ valueOrPropertyLabel }} either {{ valueOrPropertyLabelTime }}",
        less_or_equal_time: "{{ propLabel }} should be earlier or equal to {{ valueOrPropertyLabel }} either {{ valueOrPropertyLabelTime }}"
    },
    isUnique: "{{ propLabel }} should be unique",
    datesOverlap: "Invalid date(s), it's overlapping another item's date range.",
    phoneNumber: "Invalid phone number",
    coordinate: "{{propLabel}} is not a valid coordinate, or doesn't have a suitable entries number. \n Example of valid coordinates : (1,2,3) ; (.345, 7.9) ; (-2.54, +9)",
    labelDays: "D"
};

type ErrorMessageRecord = typeof _messagesEN;

/**
 * List of all french error messages by validator
 */
const _messagesFR: ErrorMessageRecord = {
    [FALLBACK_ERROR_MESSAGE]: "{{ propLabel }} n'est pas valide",
    required: "{{ propLabel }} est obligatoire",
    requiredAtLeastOne: "L'une de ces propriétés doit être renseignée",
    minValue: "La valeur minimum pour {{ propLabel }} est {{ validatorParams }}",
    maxValue: "La valeur maximum pour {{ propLabel }} est {{ validatorParams }}",
    minLength: "La longueur minimum pour {{ propLabel }} est {{ validatorParams }}",
    maxLength: "La longueur maximum pour {{ propLabel }} est {{ validatorParams }}",
    date: "{{ propLabel }} accepte uniquement le format date",
    email: "{{ propLabel }} accepte uniquement le format email",
    equal: "{{ propLabel }} devrait être égal à {{ validatorParams }}",
    isInteger: "{{ propLabel }} devrait être un nombre entier",
    sanitizeHtml: "{{ propLabel }} n'est pas dans un format valide",
    compare: {
        equal: "{{ propLabel }} devrait être égal à {{ valueOrPropertyLabel }}",
        equal_without_type: "{{ propLabel }} devrait être égal à {{ valueOrPropertyLabel }}",
        not_equal: "{{ propLabel }} ne devrait pas être égal à {{ valueOrPropertyLabel }}",
        not_equal_without_type: "{{ propLabel }} ne devrait pas être égal à {{ valueOrPropertyLabel }}",
        greater: "{{ propLabel }} devrait être supérieur à {{ valueOrPropertyLabel }}",
        greater_or_equal: "{{ propLabel }} devrait être supérieur ou égal à {{ valueOrPropertyLabel }}",
        less: "{{ propLabel }} devrait être inférieur à {{ valueOrPropertyLabel }}",
        less_or_equal: "{{ propLabel }} devrait être inférieur ou égal à {{ valueOrPropertyLabel }}",

        equal_date: "{{ propLabel }} devrait être le même jour que le {{ valueOrPropertyLabel }}",
        equal_without_type_date: "{{ propLabel }} devrait être le même jour que le {{ valueOrPropertyLabel }}",
        not_equal_date: "{{ propLabel }} ne devrait pas être le même jour que le {{ valueOrPropertyLabel }}",
        not_equal_without_type_date: "{{ propLabel }} ne devrait pas être le même jour que le {{ valueOrPropertyLabel }}",
        greater_date: "{{ propLabel }} devrait être plus tard que le {{ valueOrPropertyLabel }}",
        greater_or_equal_date: "{{ propLabel }} devrait être plus tard ou le même jour que le {{ valueOrPropertyLabel }}",
        less_date: "{{ propLabel }} devrait être plus tôt que le {{ valueOrPropertyLabel }}",
        less_or_equal_date: "{{ propLabel }} devrait être plus tôt ou le même jour que le {{ valueOrPropertyLabel }}",

        equal_time: "{{ propLabel }} devrait être la même heure que {{ valueOrPropertyLabel }} soit {{ valueOrPropertyLabelTime }}",
        equal_without_type_time: "{{ propLabel }} devrait être la même heure que {{ valueOrPropertyLabel }} soit {{ valueOrPropertyLabelTime }}",
        not_equal_time: "{{ propLabel }} ne devrait pas être la même heure que {{ valueOrPropertyLabel }} soit {{ valueOrPropertyLabelTime }}",
        not_equal_without_type_time: "{{ propLabel }} ne devrait pas être la même heure que {{ valueOrPropertyLabel }} soit {{ valueOrPropertyLabelTime }}",
        greater_time: "{{ propLabel }} devrait être plus tard que {{ valueOrPropertyLabel }} soit {{ valueOrPropertyLabelTime }}",
        greater_or_equal_time: "{{ propLabel }} devrait être plus tard ou la même heure que {{ valueOrPropertyLabel }} soit {{ valueOrPropertyLabelTime }}",
        less_time: "{{ propLabel }} devrait être plus tôt que {{ valueOrPropertyLabel }} soit {{ valueOrPropertyLabelTime }}",
        less_or_equal_time: "{{ propLabel }} devrait être plus tôt ou la même heure que {{ valueOrPropertyLabel }} soit {{ valueOrPropertyLabelTime }}"
    },
    isUnique: "{{ propLabel }} doit être unique",
    datesOverlap: "Date(s) incorrecte(s), il y a un chevauchement avec un autre élément.",
    phoneNumber: "Numéro de téléphone invalide",
    coordinate: "{{propLabel}} n'est pas une coordonnée valide, ou ne respecte pas le nombre d'entrées adéquat. \n Exemples de coordonnées valides : (1,2,3) ; (.345, 7.9) ; (-2.54, +9)",
    labelDays: "J"
};

/**
 * Default error messages per language and per validator
 */
export const ERROR_MESSAGES = {
    "en": _messagesEN,
    "fr": _messagesFR
};